module.exports = __webpack_public_path__ + "static/media/warning_icon.40d0b23c.svg";